import { useLang } from "../i18n/LanguageContext";
import { Quote, Star } from "lucide-react";

// Generate a deterministic color-pair from a name initial
const palette = (i) => (i % 2 === 0 ? "cool" : "warm");

const initials = (name) =>
  name
    .split(/[\s.]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();

export const Testimonials = () => {
  const { t } = useLang();
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-24 md:py-32 bg-ink-deep">
      <div className="absolute inset-x-0 top-0 divider-temp" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-xs font-semibold uppercase tracking-[0.22em] text-heat">{t.testimonials.eyebrow}</span>
          <h2 className="mt-4 font-heading font-bold text-white tracking-tight text-4xl sm:text-5xl leading-[1.05]" data-testid="testimonials-title">
            {t.testimonials.title}
          </h2>
          <p className="mt-5 text-white/70 text-base sm:text-lg">{t.testimonials.subtitle}</p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {t.testimonials.items.map((item, i) => {
            const accent = palette(i);
            const isCool = accent === "cool";
            return (
              <figure
                key={i}
                data-testid={`testimonial-card-${i}`}
                className={`relative rounded-3xl border border-white/10 bg-ink-card p-7 transition ${isCool ? "card-cool" : "card-warm"}`}
              >
                <Quote size={28} className={`${isCool ? "text-cool" : "text-heat"} opacity-80`} />
                <div className="mt-4 flex items-center gap-1.5">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <Star key={s} size={14} className="text-heat fill-heat" />
                  ))}
                </div>
                <blockquote className="mt-4 text-white/85 text-base sm:text-lg leading-relaxed">
                  "{item.quote}"
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-3 pt-5 border-t border-white/10">
                  <div className={`h-11 w-11 rounded-full flex items-center justify-center font-heading font-bold text-sm ${isCool ? "bg-cool/15 text-cool ring-1 ring-cool/40" : "bg-heat/15 text-heat ring-1 ring-heat/40"}`}>
                    {initials(item.name)}
                  </div>
                  <div>
                    <div className="font-heading font-bold text-white text-sm">{item.name}</div>
                    <div className="text-xs text-white/55">{item.location} · {item.service}</div>
                  </div>
                </figcaption>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
};
